import PrivateComponent from './PrivateComponent';

export default PrivateComponent;
